// eslint-disable-next-line import/prefer-default-export
export const CL = {
  cards: {
    hasSurplus: true,
  },
  orderCreation: {
    totalTableTooltip: false,
    resumeInteresRateTooltip: false,
  },
  orderDetails: {
    hasDocuments: false,
  },
  legal: {
    stakeholdersConjugal: true,
    stakeholdersHasDocuments: false,
  },
  invoicesTable: {
    totalAmountTooltip: false,
  },
  bankAccountActions: {
    hasXepelinAccountType: false,
    showCurrencyInput: false,
  },
  profileSidebar: [
    {
      key: 'profile',
      label: 'Perfil de Usuario',
      path: '/user/profile',
    },
    {
      key: 'legal',
      label: 'Información Legal',
      path: '/user/profile/legal',
    },
    {
      key: 'bankAccounts',
      label: 'Cuentas Bancarias',
      path: '/user/profile/bankaccounts',
    },
    {
      key: 'sii',
      label: 'SII',
      path: '/user/profile/sii',
    },
  ],
};
